import React from 'react';

import { updatePageLoadInteractionName } from '@atlaskit/react-ufo/interaction-metrics';
import { updatePageloadName } from '@atlaskit/react-ufo/trace-pageload';

import { expValEquals } from '@confluence/feature-experiments';

/**
 * Updates the UFO event name to
 */
export function ViewPageSplitTinyUFO({ isFabricPage }: { isFabricPage: boolean }) {
	React.useEffect(() => {
		if (!isFabricPage) {
			if (expValEquals('cc_editor_ttvc_ft_split2', 'isEnabled', true)) {
				updatePageloadName('view-page-tiny');
			} else {
				updatePageLoadInteractionName('view-page-tiny');
			}
		}
	}, [isFabricPage]);
	return null;
}
